import { render, staticRenderFns } from "./WalkingForm.vue?vue&type=template&id=2e71cf77"
import script from "./WalkingForm.vue?vue&type=script&lang=ts"
export * from "./WalkingForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports